import React, { FC, useState, useEffect, useContext } from 'react'
import { isMobile } from 'react-device-detect'
import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericButton from '../../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../../GenericComponents/GenericCloseButton'
import GenericInput from '../../../../GenericComponents/GenericInput'

import { remindUserPassword } from '../../../../Api/backendApi'

import {
  SingleSettingModalBox,
  UserDataContainer,
} from '../../style/UserProfileStyle'

interface RemindPasswordInterface {
  closeModal: Function
}

const RemindPassword: FC<RemindPasswordInterface> = ({ closeModal }) => {
  const [password, setPassword] = useState('')

  const handleRemindPassword = async () => {
    await remindUserPassword(password)
  }

  return (
    <SingleSettingModalBox>
      <GenericCloseButton onClick={closeModal} />
      <GenericRow margin={'0% 0 3% 0'}>
        <GenericTextSpan fSize={'2rem'} fWeight={'bold'}>
          Przypomnij hasło
        </GenericTextSpan>
      </GenericRow>

      <GenericRow>
        <GenericTextSpan
          fSize={'0.9rem'}
          width={isMobile ? '90%' : '60%'}
          margin={'1% 0'}
        >
          Na podany poniżej adres email zostanie wysłany pod którym możliwa
          będzie zmiana hasła.
        </GenericTextSpan>
      </GenericRow>
      <GenericRow
        justify="center"
        width={isMobile ? '90%' : '60%'}
        margin={'3% auto'}
      >
        <GenericInput
          onChange={(e: any) => setPassword(e.target.value)}
          type="email"
          placeholder={'Adres email'}
        ></GenericInput>
      </GenericRow>
      <GenericRow width={isMobile ? '90%' : '60%'} margin={'1% auto'}>
        <GenericButton
          justify="center"
          className="standard"
          onClick={() => handleRemindPassword()}
        >
          Resetuj hasło
        </GenericButton>
      </GenericRow>
    </SingleSettingModalBox>
  )
}

export default RemindPassword
